import { render, staticRenderFns } from "./EditorialContacts.vue?vue&type=template&id=5c69c340&"
import script from "./EditorialContacts.vue?vue&type=script&lang=js&"
export * from "./EditorialContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports